import { Table, Typography } from 'antd';

import styled from 'styled-components';

import { parenthesizedPublicValueStyles } from '@components/Features/FeaturesUI';

const { Text } = Typography;

export const StyledModelsTable = styled(Table)`
    .select-media {
        background: white;
        padding: 0.5rem 1rem;
        margin-bottom: 0.5rem;
        color: #000;
        cursor: pointer;
        user-select: none;
    }

    &.models-table {
        .ant-table-thead {
            display: ${(props) => props.breakpoints < 4 && 'none'};
        }
        .ant-table-tbody {
            tr {
                td {
                    cursor: pointer;
                    vertical-align: top;

                    padding: 0.5rem;

                    &.cover-image {
                        padding: 0.5rem 1rem;

                        @media only screen and (max-width: 720px) {
                            padding: 0.5rem 0;
                        }
                    }
                    &.season-model-cell {
                        padding: 0.5rem 0.35rem 0.5rem 1rem;
                        vertical-align: top;
                    }
                    &.season-add-cell {
                        padding: 0.5rem 1rem 0.5rem 0.35rem;
                        vertical-align: top;
                    }
                    &.preview-trigger {
                        padding: 4px 0;
                        border-left: ${(props) => props.theme.DefaultBorder};
                        vertical-align: middle;
                        font-size: 1.25rem;
                        min-width: 2.5em;
                    }
                    &.no-pointer {
                        cursor: default;
                    }
                    &.ant-table-row-expand-icon-cell {
                        display: none;
                    }
                    div.model-in-town {
                        padding: 0.25rem 0 0 0;
                        p {
                            font-size: ${(props) => props.theme.FontSizeSm};
                            font-weight: bold;
                            small {
                                padding-left: 0.25rem;
                                text-transform: uppercase;
                                &:before {
                                    content: '•';
                                    padding-right: 0.25rem;
                                }
                            }
                        }
                    }
                }
                &.ant-table-row-selected {
                    td {
                        background-color: ${(props) => props.theme.SelectedBackgroundColor};
                    }
                }
                &:last-child {
                    td {
                        border-bottom: none;
                    }
                }
                &.ant-table-expanded-row {
                    background: ${(props) => props.theme.LayoutBodyBackground} !important;
                    td {
                        background: none;
                    }
                }
            }
        }
    }
`;

export const FeaturesContainer = styled.div`
    margin-top: 0.15rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-size: ${(props) => (props.$smaller ? '.75rem' : '1rem')};

    dl {
        display: inline-block;
        margin-right: 0.5em;
        margin-bottom: 0;
        white-space: nowrap;
        line-height: 1em;

        dt {
            display: inline-block;
            padding: 0;
        }
        dd {
            display: inline-block;
            padding: 0 0.25em;

            ${parenthesizedPublicValueStyles}
        }

        &.feature-highlighted {
            dd {
                color: ${(props) => props.theme.PrimaryColor};
                font-weight: bold;
            }
        }

        &:after {
            content: '•';
        }

        &:last-of-type {
            margin-right: 0;
            &:after {
                content: none;
            }
        }
    }
`;

export const NameCell = styled.div`
    .name-icons {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .name {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        h1 {
            font-size: 1.25em;
            line-height: 1.1em;
            margin: 0;
            color: ${(props) => (props.$inPackage ? props.theme.PrimaryColor : 'inherit')};
            text-transform: capitalize;
            margin-right: 8px;
        }
    }

    .submission-date {
        margin-top: 1rem;
    }

    &.in-event {
        .name {
            h1 {
                color: ${(props) => props.theme.PrimaryColor};
            }
        }
    }
    &.busy {
        .name {
            h1 {
                color: ${(props) => props.theme.DangerColor};
            }
        }
    }
    &.no-busy {
        .name {
            h1 {
                color: ${(props) => props.theme.SuccessColor};
            }
        }
    }

    small {
        text-transform: uppercase;
    }

    p {
        margin-bottom: 0;
    }

    .detail {
        font-size: ${(props) => props.theme.FontSizeSm};
        margin-top: 4px;
    }

    /* Nel drawer stretto qui sotto scende il contenuto della colonna features. */
    .compact-summary {
        margin-top: 0.35rem;
    }

    @media only screen and (max-width: 720px) {
        /* padding-left: 0.5rem; */

        .name {
            h1 {
                font-size: 1.1rem;
            }
        }
    }
`;

export const PackageActionsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    min-height: 5rem;

    @media only screen and (max-width: 720px) {
        font-size: 0.9rem !important;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;

        .ant-badge {
            font-size: 0.8rem !important;
        }
    }
`;

export const CalendarActions = styled.div`
    font-size: 1.5rem;
`;
export const ModelCoverWrapper = styled.div`
    border: 2px solid ${(props) => (props.selected ? props.theme.PrimaryColor : 'transparent')};
`;

export const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    min-width: 6em;
`;

export const WallContainer = styled.div`
    margin-bottom: 40px;

    .add-models-as {
        padding: 1rem 2rem;
        border-bottom: ${(props) => props.theme.DefaultBorder};
    }

    .add-all-models {
        display: flex;
        justify-content: flex-end;
        padding: 1rem 2rem;
        border-bottom: ${(props) => props.theme.DefaultBorder};
    }

    .modeltable-card-wrapper {
        margin-top: 1rem;
    }
`;
